import type { FaireProductEntity } from "../../entity_types/product";

export const p_x5awjf96ur: FaireProductEntity = {
  token: "p_x5awjf96ur",
  type: "product",
  name: "Badass Grandpa Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/90531dda91f5a85369e5e1f6798494c49b04604dfee0d90459923ad33fc24e96.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0754653c5ee84054a13a936ff9f1933b05624365166bb64904300ad2a3c3f6ca.jpeg",
    "https://cdn.faire.com/fastly/28d25c3556baa4036e8813fa5de79fe12878ffe321b0c5d4c1bf040fcced6c74.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/4554e98f7db41e065791df8e15ef93903193480990c5472c0eefe19f9dc650c2.jpeg",
    "https://cdn.faire.com/fastly/8e65785750f6081603a985432af30a8bcf7286c690992eefcde8cc9cf7808008.jpeg"
  ],
  priceDollars: 6.75,
  description: "He spoils the grandkids. He still kind of scares dad. His stories go nowhere. Badass grandpas don’t retire—they just upgrade their sock game.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:13.356Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
